export default "__VITE_ASSET__CmCdvvhL__"